document.addEventListener('DOMContentLoaded', () => {
  const anchor = document.querySelector('.mumu-transtore-anchor');
  if (!anchor) return;

  // Transtore本体の候補（どれか当たればOK）
  const transtore =
    document.querySelector('#transtore-selector') ||
    document.querySelector('[id*="transtore"]') ||
    document.querySelector('[class*="transtore"]');

  if (!transtore) return;

  anchor.appendChild(transtore);
});

